import React, { Component } from "react";
import axios from "axios";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { MantineReactTable } from "mantine-react-table";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { endpoints } from "../../../../services/apiurl";
import { InfinitySpin } from "react-loader-spinner";
import excellogo from "../../../../assets/excel.png";
import exportlogo from "../../../../assets/export_excel.png";
import { Card, Button } from "@mui/material";
import PageTitle from "../../../UI/PageTitle";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

import {
  Typography,
  Divider,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import * as XLSX from "xlsx";

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "800px",
    width: "100%",
    position: "relative",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    maxHeight: "80vh",
    overflow: "hidden",
  },
  saveButtonFixed: {
    position: "sticky",
    bottom: 0,
    backgroundColor: "#fff",
    padding: "10px 0",
    textAlign: "center",
    borderTop: "1px solid #ccc",
    zIndex: 10,
  },
};

const getItems = (ii) =>
  Array.from({ length: ii.length }, (v, k) => k).map((k) => ({
    id: `${ii[k].id}`,
    name: ii[k].name,
    status: `${ii[k].status}`,
    show_app: `${ii[k].show_app}`,
    show_web: `${ii[k].show_web}`,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

//console.log(localStorage.getItem("user"));

class RestSectionDetail extends Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      allRestaurant: [],
      selectedRestaurant: "",
      DataisLoaded: false,
      dataIsLoaded: true,
      buttonClicked: false,
      number: 1,
      currentPage: parseInt(localStorage.getItem("currentPage")) || 1,
      totalPages: 1,
      per_page: 20,
      restro_id: this.props.match.params.restro_id,
      rest_id: this.props.match.params.restro_id,
      search: "",
      input1Value: "",
      input2Value: "",
      inputFieldValue: "",
      inputFieldValue2: "",
      data: null,
      loading: false,
      user_id: null,
      slug: "",
      suggestions: [],
      suggestions2: [],
      modalOpen: false,
      restaurantlist: [],
      columns: [],
      file: null,
      mapping: {},
    };
    this.predefinedFields = [
      { label: "Section", type: "Text" },
      { label: "Category", type: "Text" },
      { label: "Sub Category", type: "Text" },
      { label: "Dish", type: "Text" },
      { label: "Price", type: "Number" },
      { label: "Description", type: "Text" },
      { label: "Veg", type: "Text" },
      { label: "Non Veg", type: "Text" },
      { label: "Sea Food", type: "Text" },
      { label: "Egg Only", type: "Text" },
      { label: "Tax", type: "Number" },
      { label: "Vat", type: "Number" },
      { label: "Happy Price", type: "Number" },
      { label: "Start Time", type: "Time" },
      { label: "End Time", type: "Time" },
      { label: "Preparation Time", type: "Number" },
    ];

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.section_id = this.props.match.params.restro_id;
    this.props.match.params.rest_id = this.props.match.params.restro_id;

    //console.log(this.props)
    //localStorage.setItem("restro_id", this.section_id);

    //console.log(this.section_id);
  }

  openModal = () => {
    this.setState({ modalOpen: true });
  };

  closeModal = () => {
    this.setState({
      modalOpen: false,
      columns: [],
      file: null,
    });
  };

  componentDidMount() {
    this.fetchData();
    this.getRestaurant();
    this.restaurantdetails();
  }

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({ loading: true });
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const columns = jsonData[0] || []; // First row as headers

        // Initialize mapping state with empty values
        const initialMapping = columns.reduce((acc, column) => {
          acc[column] = { myColumn: "", type: "" };
          return acc;
        }, {});

        this.setState({
          columns,
          mapping: initialMapping,
          file,
          loading: false,
        });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  handleMappingChange = (excelColumn, key, value) => {
    this.setState((prevState) => {
      const updatedMapping = {
        ...prevState.mapping,
        [excelColumn]: {
          ...prevState.mapping[excelColumn],
          [key]: value,
        },
      };

      // Determine the type based on the selected 'My Column'
      const selectedField = this.predefinedFields.find(
        (field) => field.label === value
      );
      if (selectedField) {
        updatedMapping[excelColumn].type = selectedField.type;
      }

      // Log the updated mapping for the current XLS column
      console.log(
        "Updated Mapping for",
        excelColumn,
        ":",
        updatedMapping[excelColumn]
      );

      return { mapping: updatedMapping };
    });
  };

  uploadmenudata = (event) => {
    event.preventDefault();
    const { file, mapping } = this.state;

    const isAnyColumnMapped = Object.values(mapping).some(
      (mapping) => mapping.myColumn !== ""
    );

    if (!file) {
      alert("Please select a file to upload.");
      return;
    }
    if (!isAnyColumnMapped) {
      alert("Please Map The Columns.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const originalData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Extract headers from the first row
      const headers = originalData[0];
      const dataRows = originalData.slice(1); // Remaining rows

      // Filter headers and data based on mapping
      const mappedHeaders = headers
        .map((header, index) => {
          const mappingForColumn = mapping[header];
          return mappingForColumn?.myColumn
            ? { name: mappingForColumn.myColumn, index }
            : null; // Keep index for mapping rows
        })
        .filter((mappedHeader) => mappedHeader !== null); // Remove unmapped headers

      // Map only data for the mapped headers
      const updatedData = [
        mappedHeaders.map((header) => header.name), // Include only mapped header names
        ...dataRows.map(
          (row) => mappedHeaders.map((header) => row[header.index]) // Include only data corresponding to mapped columns
        ),
      ];

      // Convert the updated data back to a worksheet
      const newWorksheet = XLSX.utils.aoa_to_sheet(updatedData);

      // Create a new workbook for uploading
      const newWorkbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, sheetName);

      // Convert the workbook to a binary format for the API
      const updatedExcel = XLSX.write(newWorkbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([updatedExcel], {
        type: "application/octet-stream",
      });
      const formData = new FormData();
      formData.append("data", blob, "updatedFile.xlsx");
      formData.append("restro_id", this.section_id);

      this.setState({ loading: true });

      // API call
      axios
        .post(endpoints.uploadmenunew, formData)
        .then((response) => {
          const { statuscode, message } = response.data;

          if (statuscode === 2) {
            toast.success(message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            this.closeModal();
            this.fetchData();
          } else if (statuscode === 3) {
            toast.warning(
              message ||
              "Completed with error. Please check the uploaded data.",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              }
            );
            this.closeModal();
            this.fetchData();
          } else {
            toast.error(
              message || "Failed to upload menu data. Please try again later.",
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              }
            );
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(
            "An error occurred while uploading menu data. Please try again later.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    };

    reader.readAsArrayBuffer(file);
  };

  handleInputChange = async (value) => {
    console.error("val : ", value);
    var restro_id = this.state.restro_id;

    // console.log(value);

    this.setState({ inputFieldValue: value });
    if (value.trim().length > 0) {
      var type = "cat";

      try {
        // Make an API call based on the input value
        const response = await axios.post(endpoints.all_categoryFilter, {
          value,
          restro_id,
          type,
        });

        // Assuming your API returns an array of suggestions
        const suggestions = response.data.data; // Get the first 5 suggestions
        this.setState({ suggestions });
        console.log(suggestions);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    } else {
      // Clear suggestions if input is empty
      this.setState({ suggestions: [] });
    }
  };

  handleInputChangeDish = async (value) => {
    console.error("val : ", value);
    var restro_id = this.state.restro_id;

    // console.log(value);

    this.setState({ inputFieldValue2: value });
    if (value.trim().length > 0) {
      var type = "dish";
      try {
        const response = await axios.post(endpoints.all_categoryFilter, {
          value,
          restro_id,
          type,
        });

        const suggestions2 = response.data.data;
        this.setState({ suggestions2 });
        //console.log(suggestions2);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      }
    } else {
      // Clear suggestions if input is empty
      this.setState({ suggestions2: [] });
    }
  };

  handleSelectChange = (e) => {
    const selectedRestaurant = e.target.value;
    this.setState({ selectedRestaurant });
  };
  setCurrentPage = (page) => {
    this.setState({ currentPage: page }, () => {
      this.fetchData();
    });
  };

  handleSelectChange = (e) => {
    const selectedRestaurant = e.target.value;
    // console.log(selectedRestaurant)
    this.setState({ selectedRestaurant });
  };

  restroSubmit = (e) => {
    e.preventDefault();
    // console.log("submit");
    // console.log(this.state.selectedRestaurant);
    const data = {
      old_restro_id: this.state.selectedRestaurant,
      new_restro_id: this.props.match.params.restro_id,
    };
    //console.log(data);

    axios
      .post(endpoints.getCloneMenu, {
        old_restro_id: this.state.selectedRestaurant,
        new_restro_id: this.props.match.params.restro_id,
      })
      .then((response) => {
        //console.log("Form submitted successfully");

        if (response.data.statusCode == 3) {
          this.fetchData();
        }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error submitting form:", error);
      });
  };

  getRestaurant() {
    axios.post(endpoints.getRestaurentsDropDown).then((res) => {
      //console.log(res["data"]["data"]);
      const responseData = res["data"]["data"];
      this.setState({
        allRestaurant: responseData,
      });
      this.allRestaurant = res["data"]["data"];
      // console.log(this.allRestaurant)
    });
  }

  fetchData() {
    var restro_id = this.state.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios
      .post(endpoints.getSection, {
        page,
        per_page,
        restro_id,
      })
      .then((response) => {
        this.setState({
          items: getItems(response.data.data),
          totalPages: response.data.total_pages,
          local: localStorage.setItem(
            "data",
            JSON.stringify(response.data.data)
          ),
          DataisLoaded: true,
        });
        // console.log(response.data.data);
      });
  }
  menu() {
    var restro_id = this.state.restro_id;

    axios
      .post(
        endpoints.menuData,
        {
          restro_id,
        },
        { responseType: "blob" }
      )
      .then((response) => {
        // Create a Blob from the response data
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a download link and trigger the download
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error fetching Excel data:", error);
      });
  }

  move = (data) => {
    var restro_id = this.state.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    this.setState({ DataisLoaded: false });
    axios
      .post(endpoints.updateSectionSorting, {
        data,
        page,
        per_page,

        restro_id,
      })
      .then((response) => {
        // Assuming that response.data.data contains the updated items
        const updatedItems = getItems(response.data.data);

        //console.log(updatedItems);

        this.setState({
          items: updatedItems,
          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Error updating dish order:", error);
        // Handle error, show error message, etc.
        this.setState({ DataisLoaded: true });
      });
  };

  handleInput1Change = (e) => {
    this.setState({ input1Value: e.target.value });
  };

  handleInput2Change = (e) => {
    this.setState({ input2Value: e.target.value });
  };

  removeContactHandler = async (id) => {
    try {
      await axios.post(endpoints.deleteSection, { id });
      // Filter out the deleted item
      const newContactList = this.state.items.filter(
        (contact) => contact.id !== id
      );
      // Update the state with the new list using this.setState
      this.setState({ items: newContactList });

      // Show a success toast
      toast.success("Main Category deleted successfully!");
    } catch (error) {
      // Handle errors if necessary
      console.error("Error deleting contact:", error);
      // Show an error toast
      toast.error("Error deleting item");
    }
  };

  submit = async (id) => {
    confirmAlert({
      title: "DELETE",
      message: "Are you sure you want to Delete it?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            // Call the removeContactHandler function
            await this.removeContactHandler(id);
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  restaurantdetails = async (page, per_page) => {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    var restro_id = this.state.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;

    await axios
      .post(endpoints.getRestaurents, {
        page,
        per_page,
        user_id,
        restro_id,
      })
      .then(
        (response) => {
          const restaurantData = response.data.data;
          const slug = restaurantData.length > 0 ? restaurantData[0].slug : "";

          this.setState({
            restaurantlist: restaurantData,
            local: localStorage.setItem("data", JSON.stringify(restaurantData)),
            DataisLoaded: true,
            user_id: user_id,
            slug: slug,
          });
        },
        (error) => {
          console.error(error);
        }
      );
  };

  render() {
    const {
      loading,
      dataIsLoaded,
      user_id,
      slug,

      modalOpen,
      columns,

      buttonClicked,
    } = this.state;
    const columnss = [
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "status",
        header: "Status",
      },
      {
        accessorKey: "statusapp",
        header: "Status(App)",
      },
      {
        accessorKey: "statusweb",
        header: "Status(Web)",
      },

      {
        accessorKey: "actions",
        header: "Action",
      },
    ];

    const datas = this.state.items.map((item) => ({
      name: item.name,

      id: item.id,

      status: (
        <div class="custom-control custom-switch">
          <input
            type="checkbox"
            class="custom-control-input"
            id={item.id + "check"}
            {...(item.status === "1" ? { checked: "checked" } : {})}
            onClick={() => sub(item.id, item.status, "status")}
          />
          <label
            className="custom-control-label"
            style={{ cursor: "pointer" }}
            htmlFor={item.id + "check"}
          ></label>
        </div>
      ),

      statusapp: (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={item.id + "check1"}
            {...(item.show_app === "1" ? { checked: "checked" } : {})}
            onClick={() => sub(item.id, item.show_app, "show_app")}
          />
          <label
            className="custom-control-label"
            style={{ cursor: "pointer" }}
            htmlFor={item.id + "check1"}
          ></label>
        </div>
      ),

      statusweb: (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            className="custom-control-input"
            id={item.id + "check2"}
            {...(item.show_web === "1" ? { checked: "checked" } : {})}
            onClick={() => sub(item.id, item.show_web, "show_web")}
          />
          <label
            className="custom-control-label"
            style={{ cursor: "pointer" }}
            htmlFor={item.id + "check2"}
          ></label>
        </div>
      ),
      actions: (
        <div className="d-flex align-items-start">
          <Link to={`/dashboard/editsection/${item.id}`}>
            {" "}
            <EditIcon />{" "}
          </Link>
          <Link to={`/dashboard/categoryrest/${item.id}`} className="mx-2">
            {" "}
            <Button variant="contained">Category List</Button>{" "}
          </Link>

          <span
            className="trash alternate outline icon"
            style={{
              color: "red",
              marginTop: "7px",
              marginLeft: "10px",
              cursor: "pointer",
            }}
            onClick={() => this.submit(item.id)}
          >
            <ToastContainer />

            <DeleteIcon />
          </span>
        </div>
      ),
    }));

    const { DataisLoaded } = this.state;

    const sub = async (id, old_status, col_name) => {
      try {
        const newStatus = old_status === "1" ? "0" : "1";

        const response = await axios.post(endpoints.app_webSecRestStatus, {
          id,
          status: newStatus,
          col_name,
        });

        this.setState((prevState) => ({
          DataisLoaded: true,
          items: prevState.items.map((item) =>
            item.id === id ? { ...item, [col_name]: newStatus } : item
          ),
        }));

        // Display toaster notification for status change
        toast.success(
          `${col_name} ${newStatus === "1" ? "Active" : "Inactive"}`
        );
      } catch (error) {
        console.error(`Error updating ${col_name} status:`, error);

        // Display error toaster notification
        toast.error(`Error updating ${col_name} status`);
      }
    };

    const setCurrentPage = (id) => {
      this.state.currentPage = id;
      this.fetchData();
    };

    const onSelectChange = (per_page) => {
      this.state.per_page = per_page;
      this.fetchData();
    };

    return (
      <div className="App">
        <Card className="m-3">
          <div className="row mb-5">
            <div className="col col-3">
              {/* Input field with onChange event */}
              <label>Category </label>
              <input
                type="text"
                className="form-control"
                value={this.state.inputFieldValue}
                onChange={(e) => this.handleInputChange(e.target.value)}
                placeholder="Category Search"
              />

              <ul
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  // padding: "5px",
                  borderRadius: "5px",
                }}
              >
                {this.state.suggestions.map((suggestion, index) => (
                  <li key={index}>
                    <Link
                      to={`/dashboard/categoryrest/${suggestion.section_id}?filter2=${suggestion.c_name}`}
                    >
                      {suggestion.s_name} : {suggestion.c_name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col col-3">
              {/* Input field with onChange event */}
              <label>Dish </label>
              <input
                type="text"
                className="form-control"
                value={this.state.inputFieldValue2}
                onChange={(e) => this.handleInputChangeDish(e.target.value)}
                placeholder="Dish Search"
              />

              <ul
                style={{
                  maxHeight: "150px",
                  overflowY: "auto",
                  border: "1px solid #ccc",
                  // padding: "5px",
                  borderRadius: "5px",
                }}
              >
                {this.state.suggestions2.map((suggestion, index) => (
                  <li key={index}>
                    <Link
                      to={`/dashboard/dishrestdetail/${suggestion.cat_id}?filter2=${suggestion.d_name}`}
                    >
                      {suggestion.s_name} : {suggestion.c_name} :
                      {suggestion.d_name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div class="col col-2">
              <label>Row Per Page </label>
              <select
                name="type"
                className="form-control"
                onChange={(e) => onSelectChange(e.target.value)}
                value={this.state.per_page}
              >

                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div
              style={{
                textAlign: "center",
                marginTop: "45px",
                marginLeft: "20px",
              }}
            >
              {user_id === 5 ? (
                <div></div>
              ) : (
                <div>
                  <Button
                    style={{ marginRight: "20px" }}
                    variant="contained"
                    href={`https://menu.firstfiddle.in/${slug}/lead-form`}
                    target="_blank"
                  >
                    Lead Form Link
                  </Button>
                  <Button
                    style={{ marginaaLeft: "20px" }}
                    variant="contained"
                    href={`https://menu.firstfiddle.in/${slug}/guest-reservation`}
                    target="_blank"
                  >
                    Reservation Form Link
                  </Button>
                </div>
              )}
            </div>

            {/* <div className="row">
        <div className="col-md-6">
          <Input
            id="name"
            label="Name"
            type="text"
            name="name"
            place="Dish Name"
            requiredInput="required"
            onChange={(e) => this.updateSearch(e.target.value)}
          />
        </div>

        <div className="mt-5 text-center">
          <Button
            className="w-50"
            onClick={this.handleSearch}
            variant="contained"
            size="medium"
          >
            Search
          </Button>
        </div>
        </div> */}

            {/* <div className="col-md-6">
                <Button onClick={()=>this.menu()}>
                    Excel Export
                </Button>
               
                    
                
                </div> */}

            {/* menu button start*/}

            {/* <div className="col col-4">
                            <form onSubmit={this.restroSubmit}>
                            <label>Menu Us </label>
                            <select 
                            name="restro_id" 
                            required 
                            className="form-control"
                            value={selectedRestaurant}
                            onChange={this.handleSelectChange}
                            >
                                <option value="">Select Restaurents</option>
                                {allRestaurant.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name}</option>;
                                })}
                            </select>
                            <div className="row">
                        <div className="col col-6">
                            <div className="mt-3">
                                <LoadingButton
                                    type="submit"
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                            </div>
                            </div>
                            </div>
                            </form>
                        </div> */}

            {/* menu button end*/}
          </div>
        </Card>

        <div className="row">
          <div class="col-md-5">
            <PageTitle
              title="Main Category List"
              linkid={this.props.match.params.restro_id}
              linkurl="/dashboard/addsection"
              linkTitle="Add Main Category"
            />
          </div>
          <div class="col-md-2 mt-1" style={{ paddingLeft: "60px" }}>
            <Button
              className="m-2 text-nowrap"
              variant="contained"
              onClick={() => this.menu()}
              style={{ width: "200px" }}
            >
              <img src={exportlogo} width="22" height="22" className="mr-2" />
              Download Menu
            </Button>
          </div>
          <div
            className="col-md-3 mt-1"
            style={{
              display: "flex",
              justifyContent: "center",
              paddingLeft: "59px",
            }}
          >
            <Button
              className="m-2"
              variant="contained"
              onClick={this.openModal}
            >
              <img src={excellogo} width="19" height="19" className="mr-2" />
              Upload Menu Excel
            </Button>
          </div>
          <div
            className="col-md-2 mt-1"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Link to={`/dashboard/import-history/${this.section_id}`}>
              <Button className="m-2" variant="contained">
                Import Menu History
              </Button>
            </Link>
          </div>

          <div>
            {modalOpen && (
              <div style={customStyles.overlay}>
                <div style={customStyles.modal}>
                  {!dataIsLoaded && (
                    <div className="spinner">
                      <InfinitySpin
                        visible={true}
                        width="200"
                        color="#fbaa1a"
                        ariaLabel="infinity-spin-loading"
                      />
                    </div>
                  )}

                  <form className="ui form" onSubmit={this.uploadmenudata}>
                    <div
                      className="file-input-container"
                      style={{
                        marginBottom: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <h4 className="pb-3">Upload Your File</h4>
                      <div style={{ borderBottom: "1px solid red" }}></div>
                      <input
                        type="file"
                        accept=".xls, .xlsx"
                        className="excelfileupload1"
                        onChange={(e) => {
                          this.handleFileChange(e);
                          this.setState({ isFileUploaded: true });
                        }}
                      />
                      <div className="file-input-content mt-3">
                        <b className="file-input-label">
                          (Supported formats .xlsx; max file size 5 MB)
                        </b>
                        <br></br>
                        <br></br>
                        <a
                          href="https://firstfiddle-cp.s3.ap-south-1.amazonaws.com/websites/MENU_UPLOAD_SHEET.xlsx"
                          download
                          className="download-sample pt-4"
                        >
                          Download a{" "}
                          <strong className="text-primary">sample xlsx</strong>
                        </a>
                      </div>
                    </div>

                    {columns.length > 0 && (
                      <div
                        className="content-scroll-container"
                        style={{
                          maxHeight: "60vh", // Dynamic height based on viewport
                          overflowY: "auto", // Enable vertical scrolling
                          paddingBottom: "60px", // Reserve space for Save button
                        }}
                      >
                        <Typography variant="h6" align="center" gutterBottom>
                          Map Columns
                        </Typography>
                        <Divider style={{ marginBottom: "10px" }} />
                        <Box
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            gap: "10px",
                          }}
                        >
                          <Typography variant="h6" align="center">
                            XLS Column
                          </Typography>
                          <Typography variant="h6" align="center">
                            My Column
                          </Typography>
                          <Typography variant="h6" align="center">
                            Text Field
                          </Typography>
                          {this.state.columns.map((column, index) => (
                            <React.Fragment key={index}>
                              <Typography
                                style={{
                                  padding: "5px 10px",
                                  backgroundColor: "#f4f4f4",
                                  border: "1px solid #ccc",
                                  textAlign: "center",
                                  borderRadius: "4px",
                                }}
                              >
                                {column || "N/A"}
                              </Typography>
                              <Select
                                value={
                                  this.state.mapping[column]?.myColumn || ""
                                }
                                onChange={(e) =>
                                  this.handleMappingChange(
                                    column,
                                    "myColumn",
                                    e.target.value
                                  )
                                }
                                displayEmpty
                                style={{ width: "100%" }}
                              >
                                <MenuItem value="">
                                  <em>Select a field</em>
                                </MenuItem>
                                {this.predefinedFields.map((field, i) => (
                                  <MenuItem key={i} value={field.label}>
                                    {field.label}
                                  </MenuItem>
                                ))}
                              </Select>
                              <TextField
                                value={this.state.mapping[column]?.type || ""}
                                disabled // Non-editable field
                                placeholder="Type (text/number)"
                                style={{ width: "100%" }}
                              />
                            </React.Fragment>
                          ))}
                        </Box>
                      </div>
                    )}

                    {/* Fixed Save button */}
                    {this.state.isFileUploaded && (
                      <div style={customStyles.saveButtonFixed}>
                        <LoadingButton
                          type="submit"
                          loading={loading}
                          disabled={buttonClicked}
                          variant="contained"
                          startIcon={<SaveIcon />}
                          size="medium"
                          onClick={this.uploadmenudata}
                          style={{
                            width: "50%",
                            maxWidth: "400px",
                            marginTop: "20px",
                          }}
                        >
                          {loading && <CircularProgress size={24} />}
                          {!loading && "Save"}
                        </LoadingButton>
                      </div>
                    )}
                  </form>

                  <span
                    onClick={this.closeModal}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "black",
                    }}
                  >
                    <CloseIcon />
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        <MantineReactTable
          autoResetPageIndex={false}
          columns={columnss}
          data={datas}
          enableColumnActions={false}
          enableColumnFilters={false}
          enableSorting={false}
          enableGlobalFilter={false}
          enableRowOrdering
          enableBottomToolbar={false}
          enablePagination={false}
          mantineRowDragHandleProps={({ table }) => ({
            onDragEnd: () => {
              const { draggingRow, hoveredRow } = table.getState();
              if (hoveredRow && draggingRow) {
                const newData = [...datas];
                const draggedItemId = draggingRow.original.id;

                newData.splice(
                  hoveredRow.index,
                  0,

                  {
                    ...newData.splice(draggingRow.index, 1)[0],
                    id: draggedItemId,
                  }
                );

                const idIndexMap = {};
                newData.forEach((item, index) => {
                  idIndexMap[item.id] = index;
                });

                this.setState({ items: newData });
                this.move(idIndexMap);
              }
            },
            style: { cursor: "grab" },
          })}
        />

        {!DataisLoaded && (
          <div className="spinner">
            <InfinitySpin
              visible={true}
              width="200"
              color="#fbaa1a"
              ariaLabel="infinity-spin-loading"
            />
          </div>
        )}

        <Pagination
          {...bootstrap5PaginationPreset}
          current={this.state.currentPage}
          total={this.state.totalPages}
          onPageChange={(e) => setCurrentPage(e)}
        />
      </div>
    );
  }
}

export default withRouter(RestSectionDetail);
